module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"header":"Choose a tag","createHeader":"Create new tag","buttonText":"Create a new tag","editOptions":"Edit options","applyEmptyTag":"Add tag","removeEmptyTag":"Remove tag","search":"Search","emptySearch":"No results found for \\"{search}\\""}}')
  delete Component.options._Ctor
}
